import { comparer, computed, makeObservable } from "mobx";
import type { SourceFileIndexEntry } from "./IndexEntry";
import { fileIsNamespacedModelSchemaMetadata, fileIsNonNamespacedModelSchemaMetadata } from "./file-based-actions/filePathUtils";
import { memoize } from "./Memoizable";

export class FileSetCache {
  memos: Record<string, any> = {};

  constructor(readonly files: () => SourceFileIndexEntry[], readonly canHaveNamespacedModels: boolean, readonly memoize: boolean) {
    makeObservable(this);
  }

  @memoize
  @computed({ equals: comparer.shallow })
  get schemaFiles() {
    return this.files().filter((file) =>
      this.canHaveNamespacedModels ? fileIsNamespacedModelSchemaMetadata(file) : fileIsNonNamespacedModelSchemaMetadata(file)
    );
  }

  @memoize
  @computed({ equals: comparer.shallow })
  get schemaFilePaths() {
    return this.schemaFiles.map((file) => file.path);
  }
}
